import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Modal, Tooltip } from 'antd';
import { Button, FormContext, FormDatePicker, FormItem, FormSubmitButton, MasterDetailForm, Widget } from '@digital/ui';
import { Visibility } from '@app/components';
import { ordemCompraIdState, reloadVendorListState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { enviarEmailsPropostasTecnicas } from '@app/api/sas/sasProposta';
import { getDadosData } from '@app/api/sas/ordemCompra';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import TipoOptions from '@app/types/core.types';
import { TagComponentV2 } from '@app/components/Tag/indexv2';
import { getAllUsuariosMRN, Usuario } from '@app/api/usuario';
import { uniqBy } from 'lodash';

interface Props {

}

export const ButtonModalEnviarPropostaTecnica = (props: Props) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [dataLimiteParecerTecnico, setDataLimiteParecerTecnico] = useState<string | null>(null);
    const [emails, setEmails] = useState<TipoOptions[]>([]);
    const [open, setOpen] = useState(false);

    const onCancel = () => {
        setReloadVendorList(!reloadVendorList);
        setOpen(false);
    };

    useEffect(() => {
        if (!ordemCompraId) return;
        getDadosData(ordemCompraId, undefined, undefined, EGuidFluxoProcessoEtapa.ParecerTecnico)
            .then((data: any) => {
                if (data && data.dataLimite) setDataLimiteParecerTecnico(data.dataLimite);
            });
    }, [ordemCompraId]);

    const onSubmit = (values: any) => {
        Modal.confirm({
            title: 'Confirmar envio de proposta técnica',
            content: 'Deseja enviar para os destinatários TODAS as propostas técnicas?',
            cancelText: 'Cancelar',
            onCancel: () => { },
            okText: 'Confirmar',
            onOk: () => {
                Modal.confirm({
                    title: 'Confirmação Envio de Email',
                    content:
                        'Você deseja enviar este e-mail?',
                    cancelText: 'Não',
                    onCancel: () => {
                        enviarEmailsPropostasTecnicas({
                            ordemCompraId: ordemCompraId,
                            destinatarios: values.destinatarios,
                            enviarEmail: false,
                            dataLimite: values.dataLimite
                        }).then((response: any) => {
                            if (response && response.valid) {
                                onCancel();
                            }
                        });
                    },
                    okText: 'Sim',
                    onOk: () => {
                        enviarEmailsPropostasTecnicas({
                            ordemCompraId: ordemCompraId,
                            destinatarios: values.destinatarios,
                            enviarEmail: true,
                            dataLimite: values.dataLimite
                        }).then((response: any) => {
                            if (response && response.valid) {
                                onCancel();
                            }
                        });
                    },
                });
            },
        });
    };

    useEffect(() => {
        getAllUsuariosMRN()
            .then((response: Usuario[] | undefined) => {
                if (response) {
                    const emailsOpts = response.map((item: Usuario, index, self) => {
                        return {
                            text: item.email,
                            value: item.email
                        } as TipoOptions;
                    });
                    setEmails([...uniqBy(emailsOpts, 'value').sort((a, b) => a.value - b.value)]);
                }
            });
    }, []);

    const onModalOpen = () => {
        setOpen(!open);
    };

    return (
        <>
            <Tooltip title="Enviar Proposta Técnica">
                <Button onClick={onModalOpen}>Enviar para gestor técnico</Button>
            </Tooltip>
            <Visibility visible={open} >

                <MasterDetailForm
                    key="formButtonModalEnviarPropostaTecnica"
                    onSubmit={onSubmit}
                    validationSchema={Yup.object().shape({
                        destinatarios: Yup.array()
                            .min(1, 'É necessário adicionar no mínimo 1 destinatário'),
                        dataLimite: Yup.string().nullable().required('Data limite é obrigatória'),
                    })}
                >
                    <Modal
                        onCancel={onCancel}
                        title='Enviar Proposta Técnica'
                        visible={open}
                        footer={[
                            <Button title='Fechar' onClick={onCancel} type="link" />,
                            <FormSubmitButton noIcon type="primary" title='Enviar' />
                        ]}
                    >
                        <FormContext.Consumer>
                            {({ formProps }) => (
                                <Widget >
                                    <FormDatePicker
                                        label="Data Limite de Resposta"
                                        name="dataLimite"
                                        format="DD/MM/YYYY"
                                        span={4}
                                        disabledDate={function(current) {
                                            if (!dataLimiteParecerTecnico) return false;
                                            var limite = new Date(dataLimiteParecerTecnico);
                                            limite.setHours(23, 59, 59, 999);
                                            return current && current.toDate() > limite;
                                        }}
                                    />
                                    <FormItem name='destinatarios'>
                                        <TagComponentV2
                                            buttonText="Novo destinatário"
                                            isValidateEmail
                                            hasLoadSelect={true}
                                            onLoadListSelect={async () =>
                                                emails
                                            }
                                            onChange={function (value: string[]): void {
                                                if (formProps) {
                                                    formProps.setFieldValue('destinatarios', value);
                                                }
                                            }}
                                        />
                                    </FormItem>
                                </Widget>
                            )}
                        </FormContext.Consumer>
                    </Modal>
                </MasterDetailForm>
            </Visibility>
        </>
    );
};
